var ctrlopt = ctrlopt,
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;

  /* Concrete View */
  apptBook.LocationSelectSection = function (container) {
    apptBook.LocationSelectSection.superclass.constructor.call(this);
    this.id = 'counters';
    this.container = container;
    this.selectMenu = container.find('select.location-select');
    this.submitBtn = container.find('.location-submit');
    this.boundTransIn = this.onTransIn.bind(this);
    this.initialized = false;
    this.stores = {};
  };

  ctrlopt.extend(apptBook.LocationSelectSection, apptBook.AbstractSection);

  apptBook.LocationSelectSection.prototype.buildSelectMenu = function () {
    var me = this;

    if (!this.countersData || !this.selectMenu.length) {
      return;
    }

    for (var i = 0, len = this.countersData.length; i < len; i += 1) {
      var storeName = this.countersData[i].name,
        optionText = this.countersData[i].town + ' - ' + storeName + ', ' + this.countersData[i].address1,
        optionValue = this.countersData[i].id,
        newOption = $('<option value="' + optionValue + '">' + optionText + '</option>'),
        storeNum = this.countersData[i].store_no,
        maxSelections = this.countersData[i].max_appointment_services;

      this.stores[optionValue] = {
        store: storeNum,
        name: storeName,
        maxSelections: maxSelections
      };

      // Don't filter out counters
      this.selectMenu.append(newOption);

      // filter out counters with no services and counters with no calendars
      /* if (this.countersData[i].service_ids.length > 0 && this.countersData[i].calendars.length > 0) {
        this.selectMenu.append(newOption);
      }*/
    }

    this.selectMenu.on('change', function (e) {
      if (this.value === '0') {
        me.submitBtn.addClass('disabled');
      } else {
        me.submitBtn.removeClass('disabled');
      }
    });
  };

  apptBook.LocationSelectSection.prototype.setSubmitHandler = function () {
    var me = this;

    function onSubmit(e) {
      var updateData,
        select = me.selectMenu[0],
        counterId = select.options[select.selectedIndex].value;

      e.preventDefault();

      if ($(this).hasClass('disabled')) {
        return;
      }

      if (counterId) {
        site.track.evtLink({
          event_name: 'appointmentBooking_Location',
          event_category: 'appointment booking',
          event_action: 'location chosen',
          event_label: me.stores[counterId].store + ' - ' + me.stores[counterId].name
        });

        updateData = {
          sectionId: 'next',
          params: {
            sectionId: me.id,
            counterId: counterId,
            maxSelections: me.stores[counterId].maxSelections,
            updateMode: me.updateMode
          }
        };
        me.model.update(updateData);
      }
    }

    this.submitBtn.click(onSubmit);
  };

  apptBook.LocationSelectSection.prototype.onTransIn = function () {
    var sBoxes = this.container.find('.selectbox');

    site.util.refreshSelectBoxes(sBoxes);
  };

  apptBook.LocationSelectSection.prototype.onUpdate = function (data) {
    var me = this,
      aPgName = document.title + ' - Location Select';

    if (data.sectionId === this.id) {
      apptBook.sectionManager.on('transition_in_start', this.boundTransIn);
      if (data.params.updateMode) {
        this.updateMode = true;
      } else {
        this.updateMode = false;
      }
      if (!this.initialized) {
        this.initialized = true;
        this.model.getCounters(function (cData) {
          me.countersData = cData;
          me.buildSelectMenu();
          me.setSubmitHandler();
        });
      }
    } else {
      apptBook.sectionManager.off('transition_in_start', this.boundTransIn);
    }
  };

  Drupal.behaviors.apptBookLocation = {
    attach: function (context) {
      var view = new apptBook.LocationSelectSection($('#counters'));

      view.setModel(apptBook.sectionModel).startObserving();
    }
  };
})(jQuery);
